import { gridTpl } from '../../../../../common/grid/grid.controller';

export const protectiveEquipmentTestsGrid = {
    bindings: {
        onSelect: '&'
    },
    controller: 'ProtectiveEquipmentTestsGridController',
    ...gridTpl
};
